import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'event-target-polyfill';

import 'polyfills';

import ReactOnRails from 'react-on-rails';

import { registerWithRailsContext } from '../components/RailsContext';
import Store from '../components/Store';
import layoutComponents from '../layoutComponents';

require('@rails/ujs').start();
require('@rails/activestorage').start();

ReactOnRails.registerStore({ Store });

registerWithRailsContext(layoutComponents);
